import { parseEntityLines, extractMarkdownLink } from "./parse";
import { EntityChip } from "../EntityChip";

const ENTITY_URL_PATTERN =
  /(?:map\.combify\.com|staging\.eu-west-1\.combify\.com|localhost(?::\d+)?)\/(property|project|permit|tender)\/([^\s)]+)/;

interface EntityListProps {
  content: string;
  onEntityClick?: (entityType: string, entityId: string, name: string) => void;
}

export function EntityList({ content, onEntityClick }: EntityListProps) {
  const rows = parseEntityLines(content);
  if (rows.length === 0) return null;

  return (
    <div className="cx-entity-list">
      {rows.map((cols, ri) => {
        // First column: entity link → EntityChip
        const firstCol = cols[0] ?? "";
        const link = extractMarkdownLink(firstCol);
        const restCols = cols.slice(1).filter((c) => c.length > 0);

        return (
          <div key={ri} className="cx-entity-list-row">
            <span className="cx-entity-list-name">
              {link && onEntityClick ? (() => {
                const entityMatch = link.url.match(ENTITY_URL_PATTERN);
                if (entityMatch) {
                  return (
                    <EntityChip entityType={entityMatch[1]!} entityId={entityMatch[2]!} onClick={onEntityClick}>
                      {link.name}
                    </EntityChip>
                  );
                }
                return <span>{link.name}</span>;
              })() : (
                <span>{firstCol}</span>
              )}
            </span>
            {restCols.length > 0 && (
              <span className="cx-entity-list-desc">
                {restCols.join(" · ")}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
